import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatCount } from '@/utils/number';
import { verifyPcmpDisbursements } from '../api/pcmpDisburseVerify.api';
import type {
  PcmpDisburseVerifyPayload,
  PcmpDisburseVerifyResult,
} from '../types/pcmpDisburseVerify.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

function successTitle({ verified, skipped }: PcmpDisburseVerifyResult): string {
  const title = `${formatCount(verified, 'disbursement')} verified`;
  // Legacy said "N verified, M skipped": verified meanwhile, or no longer disbursed.
  return skipped > 0 ? `${title}, ${formatCount(skipped, 'proposal')} skipped` : title;
}

/** MIS / Admin verify one or many payouts of a Pending tab (LDS-770). */
export function useVerifyPcmpDisbursements(onSuccess: (result: PcmpDisburseVerifyResult) => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpDisburseVerifyPayload) => verifyPcmpDisbursements(payload),
    ...pcmpActionCallbacks(queryClient, successTitle, onSuccess),
  });
}
